import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IonicModule } from '@ionic/angular';
import { CoreModule } from './core/core.module';
import { PortalModule } from './portal/portal.module';
import { HttpClientModule } from '@angular/common/http';
import { LoadingComponent } from './features/shared-components/loading/loading.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		HttpClientModule,
		AppRoutingModule,
		CoreModule,
		PortalModule,
		IonicModule.forRoot({ swipeBackEnabled: true }),
		LoadingComponent,
		RecaptchaV3Module,
	],
	providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaSite }],
	bootstrap: [AppComponent],
})
export class AppModule {}
